import React, { useState } from 'react';
import { Label, Modal, ModalHeader, ModalBody, Form, FormGroup, FormFeedback, Button, Input } from 'reactstrap';
import { FileUploader } from 'devextreme-react';
import styles from './aea-file-modal.module.scss';

export interface IAEAFileModal {
    openModal: boolean;
    documentsHeader: string;
    documentsInputName: string;
    documentsInputNameRequired: string;
    documentsInputFile: string;
    documentsInputFileRequired: string;
    saveButton: string;
    cancelButton: string;

    onCancel(): void;
    onSendDocument(value: any): void;
}

const AEAFileModal = (props: IAEAFileModal) => {

    const [file, setFile] = useState([]);
    const [documentName, setDocumentName] = useState('');
    const [inputIsValid, setInputIsValid] = useState(true);
    const [fileIsValid, setFileIsValid] = useState(true);

    const onSubmitForm = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();

        let isValid: boolean = true;
        let fileIsValid: boolean = true;
        let inputIsValid: boolean = true;

        if (file.length === 0) {
            isValid = false;
            fileIsValid = false;
        }

        if (documentName === "" || !documentName) {
            isValid = false;
            inputIsValid = false;
        }

        setInputIsValid(inputIsValid);
        setFileIsValid(fileIsValid);

        if (isValid) {
            props.onSendDocument({
                documentName: documentName,
                file: file[0]
            });
        }
    }

    const onCancel = () => {
        props.onCancel();
    }

    return (
        <>
            {props.openModal ?
                <>
                    <Modal isOpen={props.openModal}>
                        <ModalHeader>{props.documentsHeader}</ModalHeader>
                        <ModalBody>
                            <Form onSubmit={onSubmitForm}>
                                <FormGroup>
                                    <Label>{props.documentsInputName}</Label>
                                    <Input
                                        onChange={(e: any) => { setDocumentName(e.target.value); setInputIsValid(true) }}
                                        invalid={!inputIsValid}
                                        type="text" />
                                    {
                                        !inputIsValid ? <FormFeedback>{props.documentsInputNameRequired}</FormFeedback> : null
                                    }
                                </FormGroup>
                                <FormGroup>
                                    {/* <Label>{props.documentsInputFile}</Label> */}
                                    <FileUploader
                                        selectButtonText={props.documentsInputFile}
                                        labelText=""
                                        uploadMode="useForm"
                                        onValueChanged={(e) => { if (e.value) { setFile(e.value); setFileIsValid(true) } }}
                                        isValid={fileIsValid} />

                                    {
                                        !fileIsValid ? <div className="invalid-feedback" style={{ display: "block" }}>{props.documentsInputFileRequired}</div> : null
                                    }
                                </FormGroup>
                                <div className={styles.buttons}>
                                    <Button color="secondary" type="button" onClick={onCancel}>{props.cancelButton}</Button>
                                    <Button color="primary" type="submit">{props.saveButton}</Button>
                                </div>
                            </Form>
                        </ModalBody>
                    </Modal>
                </>
                : null
            }
        </>
    );
}

export default AEAFileModal;